import { FormProvider } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const Form: FunctionComponent<Props> = ({ children, className, form, testId = TEST_ID }) => (
    <FormProvider {...form} className={className} data-testid={testId}>
        {children}
    </FormProvider>
);

export default Form;
